import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "waitingLobby.title",
    defaultMessage: "Waiting for caregiver...",
    description: "Title text",
  },
  participantTitle: {
    id: "waitingLobby.participants.title",
    defaultMessage: "Participants",
    description: "Participant title",
  },
  meetingNotFoundErrorTitle: {
    id: "waitingLobby.error.meeting.notfound.title",
    defaultMessage: "Meeting not found!",
    description: "Error title when meeting not found",
  },
  meetingNotFoundErrorDescription: {
    id: "waitingLobby.error.meeting.notfound.description",
    defaultMessage: "The meeting you are looking for could not be found.",
    description: "Error description when meeting not found",
  },
});
